import IBimehNamehDto from '../../../../Commands/Soddor/IBimehNamehDto';

export const BimehNamehInitialStateSodoor: IBimehNamehDto = {
  darsadTakhfifSalesBG: 0,
  darsadTakhfifHavadesBG: 0,
  tedaadSaalHavadesBG: 0,
  tedaadSaalSalesBG: 0,
  vaziatKhesaratSalesBGCoreId: '',
  vaziatKhesaratHavadesBGCoreId: '',
  tarikhShoroo: null,
  moddatBimehNamehId: 0,
  taahodMaali: 0,
};
